module.exports = __webpack_public_path__ + "images/FlipCard_loop.gif";